import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.simulator');
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type RouteId = 'alpha' | 'bravo' | 'charlie';
type ThreatId = 'jamming' | 'hijack' | 'sniffing';
type FlightMode = 'normal' | 'warning' | 'alert' | 'countermeasure' | 'neutralized' | 'complete';

interface Point {
    x: number;
    y: number;
}

interface PathSegment {
    start: Point;
    c1: Point;
    c2: Point;
    end: Point;
}

interface RouteOption {
    id: RouteId;
    button: string;
    title: string;
    codename: string;
    summary: string;
    speed: number;
    altitude: number;
    duration: number;
    d: string;
    segments: PathSegment[];
    waypoints: Point[];
}

interface ThreatScenario {
    id: ThreatId;
    button: string;
    title: string;
    hud: string;
    detail: string;
    defense: string;
    origin: Point;
    severity: 'WARNING' | 'ALERT' | 'CRITICAL';
    tone: 'amber' | 'red';
    icon: string;
}

interface TelemetryMetric {
    id: string;
    label: string;
    value: string;
    unit: string;
    percent: number;
    tone: string;
    icon: string;
}

interface MissionEvent {
    time: string;
    title: string;
    detail: string;
    tone: string;
    icon: string;
}

interface PacketParticle {
    id: number;
    x: number;
    y: number;
    branch: boolean;
}

@Component({
    selector: 'wiz-page-simulator',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.simulator/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.uav-dashboard {
  --bg: #071012;
  --panel: #10191c;
  --panel-2: #142124;
  --panel-3: #19282b;
  --line: rgba(143, 183, 174, .22);
  --line-strong: rgba(199, 244, 229, .42);
  --text: #eef8f4;
  --muted: #9aaca6;
  --soft: #6e837d;
  --green: #45d39a;
  --cyan: #22d3ee;
  --blue: #5aa7ff;
  --amber: #f4b860;
  --red: #ff5c5c;
  min-height: 100vh;
  overflow: hidden;
  background: #071012;
  color: var(--text);
  font-family: SUIT, Arial, sans-serif;
  letter-spacing: 0;
}

button {
  font: inherit;
}

.panel-toolbar h2,
.control-heading h2 {
  margin: 0;
  letter-spacing: 0;
}

.mission-card p,
.toggle-copy,
.protocol-status span,
.hud-panel p {
  margin: 0;
  color: var(--muted);
  line-height: 1.5;
}

.section-kicker {
  display: block;
  color: var(--green);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.event-row span {
  display: block;
  color: var(--soft);
  font-size: 9px;
  text-transform: uppercase;
}

.mission-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 350px;
  gap: 16px;
  padding: 10px 24px 14px;
}

.map-panel,
.control-panel {
  min-width: 0;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--panel);
  box-shadow: 0 18px 44px rgba(0, 0, 0, 0.24);
}

.panel-toolbar,
.control-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}

.panel-toolbar {
  padding: 16px 18px 13px;
  border-bottom: 1px solid rgba(143, 183, 174, 0.15);
}

.panel-toolbar h2,
.control-heading h2 {
  margin-top: 4px;
  font-size: 16px;
}

.toolbar-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.route-chip,
.time-chip {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0 9px;
  border: 1px solid var(--line);
  border-radius: 6px;
  color: var(--muted);
  background: #0a1416;
  font-size: 10px;
  white-space: nowrap;
}

.chip-alpha {
  color: var(--green);
  border-color: rgba(69, 211, 154, 0.42);
}

.chip-bravo {
  color: var(--amber);
  border-color: rgba(244, 184, 96, 0.44);
}

.chip-charlie {
  color: var(--blue);
  border-color: rgba(90, 167, 255, 0.44);
}

.map-canvas {
  position: relative;
  margin: 16px 18px 0;
  overflow: hidden;
  border: 1px solid rgba(143, 183, 174, 0.18);
  border-radius: 8px;
  background: #091315;
  aspect-ratio: 1000/620;
}

.map-telemetry {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 3;
  width: min(336px, 100% - 32px);
  overflow: hidden;
  border: 1px solid rgba(143, 183, 174, 0.3);
  border-radius: 8px;
  background: rgba(8, 19, 21, 0.9);
  backdrop-filter: blur(10px);
  pointer-events: none;
}

.map-flight-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(143, 183, 174, 0.17);
}

.map-flight-status > span,
.map-metric > span {
  color: var(--soft);
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.map-flight-status strong {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--green);
  font-size: 11px;
  white-space: nowrap;
}

.map-flight-status strong i {
  font-size: 10px;
}

.map-telemetry.mode-warning .map-flight-status strong {
  color: var(--amber);
}

.map-telemetry.mode-alert .map-flight-status strong {
  color: var(--red);
}

.map-telemetry.mode-countermeasure .map-flight-status strong {
  color: var(--cyan);
}

.map-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1px;
  background: rgba(143, 183, 174, 0.14);
}

.map-metric {
  min-width: 0;
  padding: 9px 8px 10px;
  background: rgba(10, 20, 22, 0.94);
}

.map-metric > span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.map-metric strong {
  display: flex;
  align-items: baseline;
  gap: 3px;
  margin-top: 4px;
  color: var(--text);
  font-size: 17px;
  line-height: 1;
}

.map-metric small {
  color: var(--soft);
  font-size: 8px;
}

.map-metric.metric-green strong {
  color: var(--green);
}

.map-metric.metric-blue strong {
  color: var(--blue);
}

.map-metric.metric-amber strong {
  color: var(--amber);
}

.map-metric.metric-red strong {
  color: var(--red);
}

.navigation-positioning {
  display: grid;
  grid-template-columns: 116px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  min-height: 86px;
  padding: 7px 12px;
  border-top: 1px solid rgba(143, 183, 174, 0.17);
  background: linear-gradient(90deg, rgba(34, 211, 238, 0.07), rgba(10, 20, 22, 0.96) 58%);
}

.navigation-visual {
  display: block;
  width: 116px;
  height: 72px;
  overflow: hidden;
  border: 1px solid rgba(34, 211, 238, 0.2);
  border-radius: 5px;
}

.navigation-base {
  fill: rgba(4, 16, 19, 0.96);
}

.navigation-grid path {
  fill: none;
  stroke: rgba(90, 167, 255, 0.13);
  stroke-width: 1;
  vector-effect: non-scaling-stroke;
}

.navigation-radar circle {
  fill: none;
  stroke: rgba(34, 211, 238, 0.18);
  stroke-width: 1;
  vector-effect: non-scaling-stroke;
}

.navigation-sweep {
  fill: rgba(34, 211, 238, 0.12);
  stroke: rgba(34, 211, 238, 0.28);
  stroke-width: 1;
  transform-box: view-box;
  transform-origin: center;
  vector-effect: non-scaling-stroke;
  animation: navigationSweep 3.8s linear infinite;
}

.navigation-route,
.navigation-trail {
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  vector-effect: non-scaling-stroke;
}

.navigation-route {
  stroke: rgba(238, 248, 244, 0.35);
  stroke-width: 1.4;
  stroke-dasharray: 4 4;
}

.navigation-trail {
  stroke: var(--green);
  stroke-width: 2.2;
  stroke-linecap: round;
  stroke-dasharray: 5 3;
  filter: drop-shadow(0 0 3px rgba(69, 211, 154, 0.75));
  animation: navigationTrail 1.2s linear infinite;
}

.navigation-point {
  fill: #081315;
  stroke-width: 2;
  vector-effect: non-scaling-stroke;
}

.navigation-start {
  stroke: var(--green);
}

.navigation-target {
  stroke: var(--blue);
}

.navigation-uav-pulse {
  fill: rgba(69, 211, 154, 0.12);
  stroke: rgba(69, 211, 154, 0.75);
  stroke-width: 1.5;
  transform-box: fill-box;
  transform-origin: center;
  vector-effect: non-scaling-stroke;
  animation: navigationPulse 1.5s ease-out infinite;
}

.navigation-uav-body {
  fill: var(--green);
  stroke: #d8ffec;
  stroke-width: 1.5;
  vector-effect: non-scaling-stroke;
  filter: drop-shadow(0 0 4px rgba(69, 211, 154, 0.9));
}

.navigation-copy {
  min-width: 0;
}

.navigation-copy > span,
.navigation-copy small {
  display: block;
  color: var(--soft);
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.navigation-copy strong {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 5px;
  color: var(--green);
  font-size: 11px;
}

.navigation-dot {
  width: 6px;
  height: 6px;
  flex: 0 0 6px;
  border-radius: 50%;
  background: var(--green);
  box-shadow: 0 0 0 4px rgba(69, 211, 154, 0.12);
  animation: navigationDot 1.4s ease-in-out infinite;
}

.navigation-copy small {
  margin-top: 5px;
}

.navigation-copy code {
  display: block;
  margin-top: 5px;
  overflow: hidden;
  color: rgba(238, 248, 244, 0.9);
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.navigation-positioning.signal-lost .navigation-route,
.navigation-positioning.signal-lost .navigation-trail,
.navigation-positioning.signal-lost .navigation-radar circle,
.navigation-positioning.signal-lost .navigation-uav-pulse {
  stroke: var(--red);
}

.navigation-positioning.signal-lost .navigation-uav-body,
.navigation-positioning.signal-lost .navigation-dot {
  background: var(--red);
  fill: var(--red);
}

.navigation-positioning.signal-lost .navigation-copy strong {
  color: var(--red);
}

.navigation-positioning.signal-lost .navigation-sweep {
  fill: rgba(255, 92, 92, 0.1);
  stroke: rgba(255, 92, 92, 0.35);
}

.mission-map {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 450px;
}

.map-base {
  fill: #081315;
}

.grid-fill {
  opacity: 0.75;
}

#microGrid path {
  fill: none;
  stroke: rgba(137, 178, 167, 0.11);
  stroke-width: 1;
}

#restrictedHatch line {
  stroke: rgba(255, 92, 92, 0.42);
  stroke-width: 5;
}

.radar-zone {
  opacity: 0.7;
  animation: radarBreathe 3s ease-in-out infinite;
}

.zone-b {
  animation-delay: 0.8s;
}

.terrain {
  fill: rgba(47, 77, 73, 0.44);
  stroke: rgba(143, 183, 174, 0.14);
  stroke-width: 1;
}

.terrain-2 {
  fill: rgba(36, 62, 58, 0.62);
}

.restricted-zone {
  fill: rgba(255, 92, 92, 0.09);
  stroke: rgba(255, 92, 92, 0.55);
  stroke-width: 2;
}

.restricted-hatch {
  fill: url(#restrictedHatch);
  opacity: 0.46;
}

.zone-label {
  fill: rgba(255, 148, 148, 0.82);
  font-size: 13px;
  font-weight: 800;
}

.control-link {
  fill: none;
  stroke: rgba(34, 211, 238, 0.48);
  stroke-width: 3;
  stroke-dasharray: 10 12;
  stroke-linecap: round;
  vector-effect: non-scaling-stroke;
  animation: dashFlow 1.8s linear infinite;
}

.control-link.encrypted {
  stroke: url(#secureTunnel);
  stroke-width: 6;
  stroke-dasharray: none;
  filter: drop-shadow(0 0 8px rgba(69, 211, 154, 0.6));
}

.route-line {
  fill: none;
  stroke: rgba(198, 226, 217, 0.24);
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
  opacity: 0.72;
  vector-effect: non-scaling-stroke;
}

.route-line.active-route {
  stroke-width: 6;
  opacity: 1;
  filter: drop-shadow(0 0 9px rgba(69, 211, 154, 0.48));
}

.route-line.route-alpha.active-route {
  stroke: var(--green);
}

.route-line.route-bravo.active-route {
  stroke: var(--amber);
  filter: drop-shadow(0 0 9px rgba(244, 184, 96, 0.48));
}

.route-line.route-charlie.active-route {
  stroke: var(--blue);
  filter: drop-shadow(0 0 9px rgba(90, 167, 255, 0.48));
}

.map-canvas.threat-hijack .route-line.active-route {
  stroke: #ff7043;
  stroke-dasharray: 12 10;
  animation: routeBreak 0.55s steps(2) infinite;
}

.breadcrumb-trail {
  fill: none;
  stroke: rgba(238, 248, 244, 0.88);
  stroke-width: 2.4;
  stroke-dasharray: 1 9;
  stroke-linecap: round;
  vector-effect: non-scaling-stroke;
}

.waypoint circle {
  fill: #111d20;
  stroke: rgba(238, 248, 244, 0.84);
  stroke-width: 2;
}

.waypoint text,
.point-marker text,
.command-center text,
.attack-origin text {
  fill: rgba(238, 248, 244, 0.88);
  font-size: 13px;
  font-weight: 800;
}

.point-marker circle {
  fill: #0a1517;
  stroke-width: 3;
}

.point-marker.start circle {
  stroke: var(--green);
}

.point-marker.target circle {
  stroke: var(--blue);
  filter: drop-shadow(0 0 9px rgba(90, 167, 255, 0.55));
}

.command-center rect {
  fill: rgba(34, 211, 238, 0.13);
  stroke: rgba(34, 211, 238, 0.7);
  stroke-width: 2;
}

.command-center path {
  fill: none;
  stroke: var(--cyan);
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.attack-vector,
.leak-link,
.hijack-drift {
  fill: none;
  stroke-linecap: round;
  vector-effect: non-scaling-stroke;
}

.attack-vector {
  stroke: var(--red);
  stroke-width: 4;
  stroke-dasharray: 18 16;
  animation: dashFlow 0.7s linear infinite;
  filter: drop-shadow(0 0 10px rgba(255, 92, 92, 0.74));
}

.attack-sniffing .attack-vector {
  stroke: var(--amber);
  filter: drop-shadow(0 0 10px rgba(244, 184, 96, 0.64));
}

.attack-origin .origin-core {
  fill: #200f10;
  stroke: var(--red);
  stroke-width: 3;
}

.attack-sniffing .origin-core {
  stroke: var(--amber);
}

.origin-pulse {
  fill: none;
  stroke: var(--red);
  stroke-width: 2;
  opacity: 0.7;
  animation: attackPulse 1.3s ease-out infinite;
}

.attack-sniffing .origin-pulse {
  stroke: var(--amber);
}

.pulse-two {
  animation-delay: 0.45s;
}

.jam-ring {
  fill: none;
  stroke: var(--red);
  stroke-width: 3;
  opacity: 0.85;
  animation: jamPulse 0.85s ease-out infinite;
}

.ring-two {
  animation-delay: 0.2s;
}

.ring-three {
  animation-delay: 0.4s;
}

.hijack-drift {
  stroke: #ff7043;
  stroke-width: 4;
  stroke-dasharray: 8 10;
  animation: dashFlow 0.8s linear infinite;
}

.leak-link {
  stroke: var(--amber);
  stroke-width: 3;
  stroke-dasharray: 5 10;
  animation: dashFlow 1s linear infinite;
}

.packet-particle {
  fill: var(--cyan);
  opacity: 0.86;
  filter: drop-shadow(0 0 7px rgba(34, 211, 238, 0.85));
}

.packet-particle.branch {
  fill: var(--amber);
  filter: drop-shadow(0 0 8px rgba(244, 184, 96, 0.88));
}

.defense-shield polygon {
  fill: rgba(34, 211, 238, 0.09);
  stroke: var(--cyan);
  stroke-width: 3;
  stroke-dasharray: 9 7;
  animation: dashFlow 1.1s linear infinite;
  filter: drop-shadow(0 0 12px rgba(34, 211, 238, 0.75));
}

.shield-pulse {
  fill: none;
  stroke: rgba(34, 211, 238, 0.75);
  stroke-width: 2;
  animation: shieldPulse 1.4s ease-out infinite;
}

.pulse-b {
  animation-delay: 0.5s;
}

.drone-node .drone-body polygon {
  fill: #edfdf7;
  stroke: #071012;
  stroke-width: 2;
}

.drone-node .drone-body line,
.drone-node .drone-body circle {
  stroke: #071012;
  stroke-width: 2;
}

.drone-node .drone-body circle {
  fill: var(--green);
}

.drone-node.mode-alert .drone-body polygon {
  fill: #ffd1d1;
}

.drone-node.mode-warning .drone-body polygon {
  fill: #ffe0ab;
}

.drone-node.mode-countermeasure .drone-body polygon {
  fill: #c7f8ff;
}

.drone-node.mode-neutralized .drone-body polygon {
  fill: #d8ffec;
}

.drone-node.jittering .drone-body {
  animation: droneJitter 0.11s steps(2) infinite;
  transform-box: fill-box;
  transform-origin: center;
}

.hud-panel {
  position: absolute;
  top: 16px;
  right: 16px;
  width: min(358px, 100% - 32px);
  padding: 13px 14px;
  border: 1px solid rgba(143, 183, 174, 0.26);
  border-radius: 8px;
  background: rgba(8, 19, 21, 0.88);
  backdrop-filter: blur(10px);
}

.hud-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.hud-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--green);
  box-shadow: 0 0 0 5px rgba(69, 211, 154, 0.12);
}

.hud-header strong {
  color: var(--text);
  font-size: 12px;
}

.hud-panel p {
  margin-top: 8px;
  font-size: 11px;
}

.hud-progress {
  height: 5px;
  margin-top: 12px;
  overflow: hidden;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.08);
}

.hud-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--green);
  transition: width 0.18s linear;
}

.hud-panel small {
  display: block;
  margin-top: 7px;
  color: var(--soft);
  font-size: 9px;
}

.hud-panel.mode-alert {
  border-color: rgba(255, 92, 92, 0.48);
}

.hud-panel.mode-alert .hud-dot,
.hud-panel.mode-alert .hud-progress span {
  background: var(--red);
}

.hud-panel.mode-warning {
  border-color: rgba(244, 184, 96, 0.48);
}

.hud-panel.mode-warning .hud-dot,
.hud-panel.mode-warning .hud-progress span {
  background: var(--amber);
}

.hud-panel.mode-countermeasure {
  border-color: rgba(34, 211, 238, 0.55);
}

.hud-panel.mode-countermeasure .hud-dot,
.hud-panel.mode-countermeasure .hud-progress span {
  background: var(--cyan);
}

.mission-strip {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1px;
  margin: 0 18px 18px;
  border-top: 1px solid rgba(143, 183, 174, 0.15);
  background: rgba(143, 183, 174, 0.15);
}

.mission-card {
  min-width: 0;
  padding: 14px 15px;
  background: var(--panel);
}

.mission-card strong {
  display: block;
  margin: 6px 0 4px;
  overflow: hidden;
  color: var(--text);
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mission-card p {
  font-size: 10px;
}

.control-panel {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.control-block {
  padding: 16px;
  border-bottom: 1px solid rgba(143, 183, 174, 0.15);
}

.control-block:last-child {
  border-bottom: 0;
}

.control-heading.inline {
  align-items: center;
}

.button-stack,
.attack-grid,
.event-list {
  display: grid;
  gap: 9px;
  margin-top: 12px;
}

.route-select,
.attack-button,
.execute-defense,
.defense-toggle {
  border: 0;
  cursor: pointer;
}

.route-select {
  display: grid;
  grid-template-columns: 34px 1fr 18px;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: 272px;
  padding: 11px;
  border: 1px solid rgba(143, 183, 174, 0.17);
  border-radius: 8px;
  color: var(--text);
  background: var(--panel-2);
  text-align: left;
}

.route-select:hover,
.route-select.active-route {
  border-color: rgba(69, 211, 154, 0.55);
  background: #17282a;
}

.route-select.route-bravo.active-route {
  border-color: rgba(244, 184, 96, 0.72);
}

.route-select.route-charlie.active-route {
  border-color: rgba(90, 167, 255, 0.72);
}

.route-number {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border-radius: 7px;
  background: rgba(69, 211, 154, 0.13);
  color: var(--green);
  font-weight: 800;
}

.route-bravo .route-number {
  background: rgba(244, 184, 96, 0.13);
  color: var(--amber);
}

.route-charlie .route-number {
  background: rgba(90, 167, 255, 0.13);
  color: var(--blue);
}

.route-copy {
  min-width: 0;
}

.route-copy strong,
.route-copy small,
.attack-button strong,
.attack-button small,
.event-row strong,
.event-row small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.route-copy strong,
.attack-button strong {
  font-size: 12px;
}

.route-copy small,
.attack-button small,
.event-row small {
  margin-top: 3px;
  color: var(--soft);
  font-size: 9px;
}

.route-select > i {
  color: var(--soft);
  font-size: 11px;
}

.attack-grid {
  grid-template-columns: 1fr;
}

.attack-button {
  display: grid;
  grid-template-columns: 34px 1fr;
  align-items: center;
  gap: 10px;
  padding: 11px;
  border: 1px solid rgba(255, 92, 92, 0.22);
  border-radius: 8px;
  color: var(--text);
  background: rgba(255, 92, 92, 0.06);
  text-align: left;
}

.attack-button > i {
  display: grid;
  place-items: center;
  width: 31px;
  height: 31px;
  border-radius: 7px;
  color: var(--red);
  background: rgba(255, 92, 92, 0.14);
}

.attack-button.tone-amber {
  border-color: rgba(244, 184, 96, 0.26);
  background: rgba(244, 184, 96, 0.06);
}

.attack-button.tone-amber > i {
  color: var(--amber);
  background: rgba(244, 184, 96, 0.15);
}

.attack-button:hover,
.attack-button.selected {
  border-color: rgba(255, 92, 92, 0.68);
}

.attack-button.tone-amber:hover,
.attack-button.tone-amber.selected {
  border-color: rgba(244, 184, 96, 0.72);
}

.defense-block {
  background: linear-gradient(180deg, rgba(34, 211, 238, 0.05), rgba(69, 211, 154, 0.03));
}

.defense-toggle {
  position: relative;
  width: 50px;
  height: 28px;
  flex: 0 0 50px;
  border: 1px solid rgba(143, 183, 174, 0.26);
  border-radius: 999px;
  background: #0a1416;
}

.toggle-knob {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--soft);
  transition: transform 0.18s ease, background 0.18s ease;
}

.defense-toggle.enabled {
  border-color: rgba(69, 211, 154, 0.55);
  background: rgba(69, 211, 154, 0.13);
}

.defense-toggle.enabled .toggle-knob {
  transform: translateX(22px);
  background: var(--green);
}

.toggle-copy {
  margin-top: 10px;
  font-size: 11px;
}

.execute-defense {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 38px;
  margin-top: 12px;
  border-radius: 8px;
  color: #041214;
  background: var(--cyan);
  font-weight: 800;
}

.execute-defense:disabled {
  cursor: wait;
  opacity: 0.62;
}

.protocol-status {
  margin-top: 12px;
  padding: 11px;
  border: 1px solid rgba(34, 211, 238, 0.28);
  border-radius: 8px;
  background: rgba(34, 211, 238, 0.07);
}

.protocol-status strong {
  display: block;
  margin-bottom: 4px;
  color: var(--cyan);
  font-size: 12px;
}

.protocol-status.mode-alert {
  border-color: rgba(255, 92, 92, 0.35);
  background: rgba(255, 92, 92, 0.07);
}

.protocol-status.mode-alert strong {
  color: var(--red);
}

.protocol-status.mode-warning {
  border-color: rgba(244, 184, 96, 0.35);
  background: rgba(244, 184, 96, 0.07);
}

.protocol-status.mode-warning strong {
  color: var(--amber);
}

.protocol-status.mode-neutralized strong,
.protocol-status.mode-complete strong,
.protocol-status.mode-normal strong {
  color: var(--green);
}

.event-block {
  flex: 1;
  min-height: 0;
}

.event-list {
  max-height: 276px;
  overflow: auto;
  padding-right: 2px;
}

.event-row {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  padding: 9px 0;
  border-bottom: 1px solid rgba(143, 183, 174, 0.1);
}

.event-row:last-child {
  border-bottom: 0;
}

.event-row > i {
  display: grid;
  place-items: center;
  width: 25px;
  height: 25px;
  border-radius: 6px;
  color: var(--blue);
  background: rgba(90, 167, 255, 0.12);
  font-size: 10px;
}

.event-row strong {
  margin-top: 2px;
  color: var(--text);
  font-size: 10px;
}

.event-green > i {
  color: var(--green);
  background: rgba(69, 211, 154, 0.13);
}

.event-red > i {
  color: var(--red);
  background: rgba(255, 92, 92, 0.13);
}

.event-amber > i {
  color: var(--amber);
  background: rgba(244, 184, 96, 0.13);
}

.event-cyan > i {
  color: var(--cyan);
  background: rgba(34, 211, 238, 0.13);
}

.dashboard-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 24px 14px;
  color: var(--soft);
  font-size: 10px;
}

.dashboard-footer span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.dashboard-footer i {
  color: var(--green);
}

@keyframes dashFlow {
  to {
    stroke-dashoffset: -48;
  }
}
@keyframes routeBreak {
  50% {
    opacity: 0.38;
  }
}
@keyframes radarBreathe {
  50% {
    opacity: 0.34;
    transform: scale(1.02);
  }
}
@keyframes attackPulse {
  0% {
    opacity: 0.8;
    transform: scale(0.8);
  }
  100% {
    opacity: 0;
    transform: scale(1.75);
  }
}
@keyframes jamPulse {
  0% {
    opacity: 0.9;
    transform: scale(0.62);
  }
  100% {
    opacity: 0;
    transform: scale(1.32);
  }
}
@keyframes shieldPulse {
  0% {
    opacity: 0.75;
    transform: scale(0.72);
  }
  100% {
    opacity: 0;
    transform: scale(1.3);
  }
}
@keyframes droneJitter {
  0% {
    transform: translate(0, 0) rotate(0deg);
  }
  50% {
    transform: translate(5px, -3px) rotate(5deg);
  }
  100% {
    transform: translate(-4px, 4px) rotate(-4deg);
  }
}
@keyframes navigationSweep {
  to {
    transform: rotate(360deg);
  }
}
@keyframes navigationTrail {
  to {
    stroke-dashoffset: -16;
  }
}
@keyframes navigationPulse {
  0% {
    opacity: 0.9;
    transform: scale(0.65);
  }
  100% {
    opacity: 0;
    transform: scale(1.35);
  }
}
@keyframes navigationDot {
  50% {
    opacity: 0.45;
  }
}
@media (prefers-reduced-motion: reduce) {
  .navigation-sweep,
  .navigation-trail,
  .navigation-uav-pulse,
  .navigation-dot {
    animation: none;
  }
}
@media (max-width: 1220px) {
  .mission-layout {
    grid-template-columns: 1fr;
  }
  .control-panel {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .control-block {
    border-right: 1px solid rgba(143, 183, 174, 0.15);
  }
  .event-block {
    grid-column: span 2;
  }
}
@media (max-width: 760px) {
  .uav-dashboard {
    overflow: auto;
  }
  .mission-layout {
    padding-left: 14px;
    padding-right: 14px;
  }
  .mission-strip,
  .control-panel {
    grid-template-columns: 1fr;
  }
  .map-canvas {
    margin-left: 12px;
    margin-right: 12px;
    aspect-ratio: auto;
  }
  .mission-map {
    min-height: 390px;
  }
  .panel-toolbar,
  .control-heading {
    flex-direction: column;
  }
  .toolbar-meta {
    justify-content: flex-start;
  }
  .hud-panel {
    position: relative;
    top: auto;
    right: auto;
    width: auto;
    margin: 0;
    border-right: 0;
    border-bottom: 0;
    border-left: 0;
    border-radius: 0;
  }
  .mission-strip {
    margin-left: 12px;
    margin-right: 12px;
  }
  .control-block,
  .event-block {
    grid-column: auto;
    border-right: 0;
  }
  .dashboard-footer {
    flex-direction: column;
    align-items: flex-start;
    padding-left: 14px;
    padding-right: 14px;
    line-height: 1.45;
  }
}`],
})
export class PageSimulatorComponent implements OnInit, OnDestroy {
    public lastUpdated = 'INIT';
    public activeRouteId: RouteId = 'alpha';
    public currentMode: FlightMode = 'normal';
    public autoDefense = true;
    public activeThreatId: ThreatId | null = null;
    public defenseActive = false;
    public threatNeutralized = false;
    public altitude = 420;
    public speed = 76;
    public battery = 96;
    public linkStrength = 94;
    public missionProgress = 0;
    public dronePoint: Point = { x: 120, y: 480 };
    public plannedPoint: Point = { x: 120, y: 480 };
    public droneAngle = -22;
    public trail: Point[] = [{ x: 120, y: 480 }];
    public packetParticles: PacketParticle[] = [];

    public readonly commandCenter: Point = { x: 86, y: 535 };
    public readonly unauthorizedZone: Point = { x: 720, y: 468 };

    public readonly routeOptions: RouteOption[] = [
        {
            id: 'alpha',
            button: 'Route Alpha',
            title: '경로 1 - 표준 순항 루트',
            codename: 'STANDARD CRUISE',
            summary: '중고도 안정 순항 및 관제 링크 우선 유지',
            speed: 76,
            altitude: 420,
            duration: 28000,
            d: 'M 120 480 C 210 410 292 410 360 360 C 430 300 520 270 610 236 C 705 200 795 168 865 120',
            segments: [
                { start: { x: 120, y: 480 }, c1: { x: 210, y: 410 }, c2: { x: 292, y: 410 }, end: { x: 360, y: 360 } },
                { start: { x: 360, y: 360 }, c1: { x: 430, y: 300 }, c2: { x: 520, y: 270 }, end: { x: 610, y: 236 } },
                { start: { x: 610, y: 236 }, c1: { x: 705, y: 200 }, c2: { x: 795, y: 168 }, end: { x: 865, y: 120 } }
            ],
            waypoints: [{ x: 360, y: 360 }, { x: 610, y: 236 }, { x: 740, y: 178 }]
        },
        {
            id: 'bravo',
            button: 'Route Bravo',
            title: '경로 2 - 저고도 우회 루트',
            codename: 'LOW ALT DETOUR',
            summary: '남측 저고도 회피 후 목표 지점으로 상승 접근',
            speed: 62,
            altitude: 260,
            duration: 34000,
            d: 'M 120 480 C 215 548 330 555 430 506 C 575 436 665 382 720 286 C 770 202 828 152 865 120',
            segments: [
                { start: { x: 120, y: 480 }, c1: { x: 215, y: 548 }, c2: { x: 330, y: 555 }, end: { x: 430, y: 506 } },
                { start: { x: 430, y: 506 }, c1: { x: 575, y: 436 }, c2: { x: 665, y: 382 }, end: { x: 720, y: 286 } },
                { start: { x: 720, y: 286 }, c1: { x: 770, y: 202 }, c2: { x: 828, y: 152 }, end: { x: 865, y: 120 } }
            ],
            waypoints: [{ x: 430, y: 506 }, { x: 636, y: 384 }, { x: 760, y: 220 }]
        },
        {
            id: 'charlie',
            button: 'Route Charlie',
            title: '경로 3 - 고속 직선 침투 루트',
            codename: 'FAST DIRECT INGRESS',
            summary: '최단 시간 돌파를 위한 고속 직선형 침투',
            speed: 118,
            altitude: 520,
            duration: 19000,
            d: 'M 120 480 C 286 392 492 292 865 120',
            segments: [
                { start: { x: 120, y: 480 }, c1: { x: 286, y: 392 }, c2: { x: 492, y: 292 }, end: { x: 865, y: 120 } }
            ],
            waypoints: [{ x: 330, y: 370 }, { x: 560, y: 260 }, { x: 730, y: 182 }]
        }
    ];

    public readonly threatScenarios: ThreatScenario[] = [
        {
            id: 'jamming',
            button: 'GPS/RF Jamming',
            title: '재밍 공격',
            hud: 'ALERT: GPS SIGNAL LOST',
            detail: 'GPS 신호 단절과 RF 노이즈로 링크가 0%까지 급락합니다.',
            defense: 'Anti-Jamming INS 전환 및 Frequency Hopping으로 경로 복귀',
            origin: { x: 820, y: 515 },
            severity: 'ALERT',
            tone: 'red',
            icon: 'fa-solid fa-tower-broadcast'
        },
        {
            id: 'hijack',
            button: 'Command Hijack',
            title: '하이재킹 / 스푸핑',
            hud: 'CRITICAL: UNAUTHORIZED FLIGHT CONTROL OVERRIDE DETECTED',
            detail: '비인가 조종 명령으로 계획 경로 이탈을 유도합니다.',
            defense: 'Zero-Trust 인증 재수립 및 하드웨어 락다운으로 불법 명령 차단',
            origin: { x: 915, y: 248 },
            severity: 'CRITICAL',
            tone: 'red',
            icon: 'fa-solid fa-user-lock'
        },
        {
            id: 'sniffing',
            button: 'Packet Sniffing / MITM',
            title: '패킷 탈취 / 중간자 공격',
            hud: 'WARNING: ENCRYPTION ANOMALY / UNENCRYPTED PACKET LEAK',
            detail: '관제 링크 중간에서 텔레메트리 패킷이 공격자 노드로 분기됩니다.',
            defense: 'Dynamic Re-Keying 및 암호화 터널 강화로 탈취 라인 단절',
            origin: { x: 520, y: 586 },
            severity: 'WARNING',
            tone: 'amber',
            icon: 'fa-solid fa-network-wired'
        }
    ];

    public eventFeed: MissionEvent[] = [
        { time: '09:00:00', title: 'Mission initialized', detail: 'Route Alpha 기준 비행 애니메이션 대기', tone: 'green', icon: 'fa-solid fa-circle-check' },
        { time: '09:00:00', title: 'Secure telemetry link', detail: '관제센터-드론 링크 암호화 채널 준비', tone: 'blue', icon: 'fa-solid fa-link' }
    ];

    private animationFrameId: number | undefined;
    private routeStartTime = 0;
    private routeSamples: { [id: string]: Point[] } = {};
    private activeThreatStartedAt = 0;
    private defenseStartedAt = 0;
    private defenseTimerId: number | undefined;
    private neutralizeTimerId: number | undefined;
    private clearThreatTimerId: number | undefined;

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private ref: ChangeDetectorRef) { }

    public async ngOnInit() {
        await this.service.init();
        this.prepareRouteSamples();
        this.lastUpdated = this.formatClock();
        this.selectRoute(this.activeRouteId, false);
    }

    public ngOnDestroy(): void {
        if (this.animationFrameId !== undefined) window.cancelAnimationFrame(this.animationFrameId);
        this.clearThreatTimers();
    }

    public selectRoute(routeId: RouteId, addEvent = true): void {
        const route = this.routeOptions.find((item) => item.id === routeId) || this.routeOptions[0]!;
        this.activeRouteId = route.id;
        this.activeThreatId = null;
        this.defenseActive = false;
        this.threatNeutralized = false;
        this.currentMode = 'normal';
        this.missionProgress = 0;
        this.altitude = route.altitude;
        this.speed = route.speed;
        this.battery = 96;
        this.linkStrength = 94;
        this.routeStartTime = performance.now();
        const firstPoint = route.segments[0]!.start;
        this.plannedPoint = { ...firstPoint };
        this.dronePoint = { ...firstPoint };
        this.droneAngle = this.getAngleAt(0, this.routeSamples[route.id] || []);
        this.trail = [{ ...firstPoint }];
        this.packetParticles = [];
        this.clearThreatTimers();

        if (addEvent) {
            this.pushEvent('Route reset', `${route.button} 비행을 시작점 A에서 재개`, 'blue', 'fa-solid fa-route');
        }

        this.startAnimationLoop();
        this.ref.detectChanges();
    }

    public launchAttack(threatId: ThreatId): void {
        const threat = this.threatScenarios.find((item) => item.id === threatId);
        if (!threat) return;

        this.clearThreatTimers();
        this.activeThreatId = threat.id;
        this.threatNeutralized = false;
        this.defenseActive = false;
        this.currentMode = threat.id === 'sniffing' ? 'warning' : 'alert';
        this.activeThreatStartedAt = performance.now();
        this.pushEvent(threat.title, threat.hud, threat.tone, threat.icon);

        if (this.autoDefense) {
            this.defenseTimerId = window.setTimeout(() => this.activateDefense(), 1300);
        }

        this.startAnimationLoop();
        this.ref.detectChanges();
    }

    public activateDefense(): void {
        this.clearDefenseTimersOnly();
        this.defenseActive = true;
        this.defenseStartedAt = performance.now();
        this.currentMode = 'countermeasure';

        if (this.activeThreat) {
            this.pushEvent('Countermeasure active', this.activeThreat.defense, 'cyan', 'fa-solid fa-shield-halved');
            this.neutralizeTimerId = window.setTimeout(() => this.neutralizeThreat(), 3000);
        } else {
            this.pushEvent('Manual defense sweep', '위협 미탐지 상태에서 전자 방어막 점검 수행', 'cyan', 'fa-solid fa-shield-halved');
            this.neutralizeTimerId = window.setTimeout(() => {
                this.defenseActive = false;
                this.currentMode = this.missionProgress >= 100 ? 'complete' : 'normal';
                this.ref.detectChanges();
            }, 1700);
        }

        this.ref.detectChanges();
    }

    public toggleAutoDefense(): void {
        this.autoDefense = !this.autoDefense;

        if (this.autoDefense && this.activeThreat && !this.defenseActive && !this.threatNeutralized) {
            this.activateDefense();
        }
    }

    public refresh(): void {
        this.selectRoute(this.activeRouteId);
    }

    public routeClass(route: RouteOption): string {
        return `${route.id === this.activeRouteId ? 'active-route ' : ''}route-${route.id}`;
    }

    public threatButtonClass(threat: ThreatScenario): string {
        return `${this.activeThreatId === threat.id ? 'selected ' : ''}tone-${threat.tone}`;
    }

    public get activeRoute(): RouteOption {
        const route = this.routeOptions.find((item) => item.id === this.activeRouteId);
        return route || this.routeOptions[0]!;
    }

    public get activeThreat(): ThreatScenario | undefined {
        if (!this.activeThreatId) return undefined;
        return this.threatScenarios.find((item) => item.id === this.activeThreatId);
    }

    public get telemetry(): TelemetryMetric[] {
        return [
            { id: 'alt', label: 'Alt', value: `${this.altitude}`, unit: 'm', percent: Math.min(100, Math.round(this.altitude / 7)), tone: this.altitude < 300 ? 'amber' : 'green', icon: 'fa-solid fa-arrow-up' },
            { id: 'spd', label: 'Spd', value: `${this.speed}`, unit: 'kt', percent: Math.min(100, Math.round(this.speed / 1.35)), tone: this.speed > 105 ? 'amber' : 'blue', icon: 'fa-solid fa-gauge-high' },
            { id: 'bat', label: 'Battery', value: `${this.battery}`, unit: '%', percent: this.battery, tone: this.battery < 35 ? 'amber' : 'green', icon: 'fa-solid fa-battery-three-quarters' },
            { id: 'link', label: 'Link Strength', value: `${this.linkStrength}`, unit: '%', percent: this.linkStrength, tone: this.linkStrength < 35 ? 'red' : this.linkStrength < 70 ? 'amber' : 'green', icon: 'fa-solid fa-signal' }
        ];
    }

    public get navigationStatus(): string {
        if (this.activeThreatId === 'jamming' && !this.defenseActive && !this.threatNeutralized) return 'SIGNAL LOST';
        if (this.defenseActive) return 'INS TRACKING';
        return 'LIVE TRACKING';
    }

    public get navigationLatitude(): string {
        return (37.5665 + ((480 - this.dronePoint.y) / 100000)).toFixed(5);
    }

    public get navigationLongitude(): string {
        return (126.978 + ((this.dronePoint.x - 120) / 100000)).toFixed(5);
    }

    public get statusLabel(): string {
        if (this.currentMode === 'normal') return 'Normal';
        if (this.currentMode === 'warning') return 'Warning';
        if (this.currentMode === 'alert') return 'Alert';
        if (this.currentMode === 'countermeasure') return 'Countermeasure Active';
        if (this.currentMode === 'neutralized') return 'Threat Neutralized';
        return 'Mission Complete';
    }

    public get statusIcon(): string {
        if (this.currentMode === 'normal') return 'fa-solid fa-circle-check';
        if (this.currentMode === 'warning') return 'fa-solid fa-triangle-exclamation';
        if (this.currentMode === 'alert') return 'fa-solid fa-circle-exclamation';
        if (this.currentMode === 'countermeasure') return 'fa-solid fa-shield-halved';
        if (this.currentMode === 'neutralized') return 'fa-solid fa-shield-halved';
        return 'fa-solid fa-flag-checkered';
    }

    public get statusClass(): string {
        return `mode-${this.currentMode}`;
    }

    public get mapStateClass(): string {
        const threatClass = this.activeThreatId ? `threat-${this.activeThreatId}` : 'threat-none';
        return `${this.statusClass} ${threatClass}`;
    }

    public get hudTitle(): string {
        if (this.threatNeutralized) return 'THREAT NEUTRALIZED';
        if (this.activeThreat) return this.activeThreat.hud;
        if (this.currentMode === 'complete') return 'MISSION ROUTE COMPLETE';
        return 'MISSION LINK STABLE';
    }

    public get hudDetail(): string {
        if (this.threatNeutralized && this.activeThreat) return `${this.activeThreat.defense}. 정상 비행 궤도로 복귀 중입니다.`;
        if (this.activeThreat) return this.activeThreat.detail;
        if (this.currentMode === 'complete') return '목표 지점 B 도착. 경로 버튼을 선택하면 즉시 재비행합니다.';
        return `${this.activeRoute.button} 경로 추적 중. 자동 방어 프로토콜이 감시 중입니다.`;
    }

    public get trailPoints(): string {
        return this.trail.map((point) => `${this.formatNumber(point.x)},${this.formatNumber(point.y)}`).join(' ');
    }

    public get droneTransform(): string {
        return `translate(${this.formatNumber(this.dronePoint.x)} ${this.formatNumber(this.dronePoint.y)}) rotate(${this.formatNumber(this.droneAngle)})`;
    }

    public get droneShieldTransform(): string {
        return `translate(${this.formatNumber(this.dronePoint.x)} ${this.formatNumber(this.dronePoint.y)})`;
    }

    public get droneCssClass(): string {
        const threatClass = this.activeThreatId && !this.threatNeutralized ? `threat-${this.activeThreatId}` : 'threat-none';
        const jitter = this.activeThreatId === 'jamming' && !this.defenseActive && !this.threatNeutralized ? 'jittering' : '';
        return `${this.statusClass} ${threatClass} ${jitter}`;
    }

    public get attackLineD(): string {
        if (!this.activeThreat) return '';
        return `M ${this.activeThreat.origin.x} ${this.activeThreat.origin.y} L ${this.formatNumber(this.dronePoint.x)} ${this.formatNumber(this.dronePoint.y)}`;
    }

    public get controlLinkD(): string {
        return `M ${this.commandCenter.x} ${this.commandCenter.y} L ${this.formatNumber(this.dronePoint.x)} ${this.formatNumber(this.dronePoint.y)}`;
    }

    public get leakLinkD(): string {
        if (!this.activeThreat) return '';
        const split = this.pointBetween(this.commandCenter, this.dronePoint, 0.52);
        return `M ${this.formatNumber(split.x)} ${this.formatNumber(split.y)} L ${this.activeThreat.origin.x} ${this.activeThreat.origin.y}`;
    }

    public get hijackDriftD(): string {
        return `M ${this.formatNumber(this.plannedPoint.x)} ${this.formatNumber(this.plannedPoint.y)} C ${this.formatNumber(this.plannedPoint.x + 80)} ${this.formatNumber(this.plannedPoint.y + 95)} ${this.unauthorizedZone.x - 60} ${this.unauthorizedZone.y + 30} ${this.unauthorizedZone.x} ${this.unauthorizedZone.y}`;
    }

    public get shieldVisible(): boolean {
        return this.defenseActive || this.threatNeutralized;
    }

    public get defenseCopy(): string {
        if (this.activeThreat) return this.activeThreat.defense;
        return 'Manual shield integrity check and secure link refresh';
    }

    public get defenseButtonLabel(): string {
        if (this.defenseActive) return 'Defense Running';
        if (this.threatNeutralized) return 'Neutralized';
        return 'Execute Defense';
    }

    private startAnimationLoop(): void {
        if (this.animationFrameId !== undefined) window.cancelAnimationFrame(this.animationFrameId);

        const tick = (time: number): void => {
            this.animate(time);
            this.animationFrameId = window.requestAnimationFrame(tick);
        };

        this.animationFrameId = window.requestAnimationFrame(tick);
    }

    private animate(time: number): void {
        const route = this.activeRoute;
        const samples = this.routeSamples[route.id] || [];
        if (samples.length === 0) return;

        const progress = Math.min(1, Math.max(0, (time - this.routeStartTime) / route.duration));
        const basePoint = this.getPointAt(progress, samples);
        const baseAngle = this.getAngleAt(progress, samples);
        const visual = this.applyThreatVisual(basePoint, baseAngle, time);

        this.missionProgress = Math.round(progress * 100);
        this.plannedPoint = basePoint;
        this.dronePoint = visual.point;
        this.droneAngle = visual.angle;
        this.updateTelemetry(time, route, progress);
        this.updateTrail(visual.point);
        this.updatePacketParticles(time);
        this.lastUpdated = this.formatClock();

        if (progress >= 1 && !this.activeThreat && !this.defenseActive && !this.threatNeutralized && this.currentMode !== 'complete') {
            this.currentMode = 'complete';
            this.pushEvent('Target reached', '목표 지점 B 도착 및 경로 추적 완료', 'green', 'fa-solid fa-flag-checkered');
        }

        this.ref.detectChanges();
    }

    private applyThreatVisual(basePoint: Point, baseAngle: number, time: number): { point: Point; angle: number } {
        const threat = this.activeThreat;
        if (!threat || this.threatNeutralized) return { point: basePoint, angle: baseAngle };

        const threatElapsed = Math.max(0, time - this.activeThreatStartedAt);
        const defenseElapsed = this.defenseActive ? Math.max(0, time - this.defenseStartedAt) : 0;
        const attackRamp = Math.min(1, threatElapsed / 900);
        const defenseDecay = this.defenseActive ? Math.max(0, 1 - defenseElapsed / 2600) : 1;
        const intensity = attackRamp * defenseDecay;

        if (threat.id === 'jamming') {
            const radius = this.defenseActive ? 14 : 30;
            return {
                point: {
                    x: basePoint.x + Math.sin(time / 58) * radius * intensity,
                    y: basePoint.y + Math.cos(time / 42) * radius * intensity
                },
                angle: baseAngle + Math.sin(time / 47) * 24 * intensity
            };
        }

        if (threat.id === 'hijack') {
            const driftStrength = 0.42 * intensity;
            const point = {
                x: basePoint.x + (this.unauthorizedZone.x - basePoint.x) * driftStrength,
                y: basePoint.y + (this.unauthorizedZone.y - basePoint.y) * driftStrength
            };
            const angle = intensity > 0.08 ? this.angleBetween(basePoint, point) : baseAngle;
            return { point, angle };
        }

        return { point: basePoint, angle: baseAngle + Math.sin(time / 120) * 4 * intensity };
    }

    private updateTelemetry(time: number, route: RouteOption, progress: number): void {
        const threat = this.activeThreat;
        const defenseRatio = this.defenseActive ? Math.min(1, Math.max(0, (time - this.defenseStartedAt) / 2600)) : 0;
        let link = 94 - Math.round(progress * 6);
        let speedOffset = Math.round(Math.sin(time / 420) * 3);
        let altitudeOffset = Math.round(Math.sin(progress * Math.PI * 2) * 18);

        if (threat && !this.threatNeutralized) {
            if (this.defenseActive) {
                link = Math.round(42 + defenseRatio * 54);
                speedOffset -= Math.round((1 - defenseRatio) * 8);
            } else if (threat.id === 'jamming') {
                link = 0;
                speedOffset = -Math.round(route.speed * 0.68);
                altitudeOffset += Math.round(Math.sin(time / 70) * 44);
            } else if (threat.id === 'hijack') {
                link = 19;
                speedOffset = 24;
                altitudeOffset -= 35;
            } else {
                link = 48;
                speedOffset = -6;
            }
        }

        if (this.threatNeutralized) link = 96;

        this.altitude = Math.max(120, Math.round(route.altitude + altitudeOffset));
        this.speed = Math.max(0, route.speed + speedOffset);
        this.battery = Math.max(28, Math.round(96 - progress * 34 - (threat && !this.threatNeutralized ? 2 : 0)));
        this.linkStrength = Math.max(0, Math.min(100, link));
    }

    private updateTrail(point: Point): void {
        const lastPoint = this.trail[this.trail.length - 1];
        if (!lastPoint || this.distance(lastPoint, point) > 5 || this.missionProgress >= 100) {
            this.trail = [...this.trail.slice(-150), { ...point }];
        }
    }

    private updatePacketParticles(time: number): void {
        if (this.activeThreatId !== 'sniffing' || this.threatNeutralized) {
            if (this.packetParticles.length > 0) this.packetParticles = [];
            return;
        }

        const particles: PacketParticle[] = [];
        const splitPoint = this.pointBetween(this.commandCenter, this.dronePoint, 0.52);

        for (let index = 0; index < 8; index += 1) {
            const amount = ((time / 1500) + index / 8) % 1;
            const point = this.pointBetween(this.commandCenter, this.dronePoint, amount);
            particles.push({ id: index, x: point.x, y: point.y, branch: false });
        }

        if (!this.defenseActive) {
            const origin = this.activeThreat ? this.activeThreat.origin : splitPoint;
            for (let index = 0; index < 6; index += 1) {
                const amount = ((time / 1180) + index / 6) % 1;
                const point = this.pointBetween(splitPoint, origin, amount);
                particles.push({ id: index + 10, x: point.x, y: point.y, branch: true });
            }
        }

        this.packetParticles = particles;
    }

    private neutralizeThreat(): void {
        if (!this.activeThreat) return;

        this.threatNeutralized = true;
        this.defenseActive = false;
        this.currentMode = 'neutralized';
        this.pushEvent('THREAT NEUTRALIZED', `${this.activeThreat.title} 대응 완료. 계획 경로 복귀`, 'green', 'fa-solid fa-shield-halved');
        this.clearThreatTimerId = window.setTimeout(() => {
            this.activeThreatId = null;
            this.threatNeutralized = false;
            this.currentMode = this.missionProgress >= 100 ? 'complete' : 'normal';
            this.packetParticles = [];
            this.ref.detectChanges();
        }, 2600);
        this.ref.detectChanges();
    }

    private clearThreatTimers(): void {
        this.clearDefenseTimersOnly();
        if (this.clearThreatTimerId !== undefined) window.clearTimeout(this.clearThreatTimerId);
        this.clearThreatTimerId = undefined;
    }

    private clearDefenseTimersOnly(): void {
        if (this.defenseTimerId !== undefined) window.clearTimeout(this.defenseTimerId);
        if (this.neutralizeTimerId !== undefined) window.clearTimeout(this.neutralizeTimerId);
        this.defenseTimerId = undefined;
        this.neutralizeTimerId = undefined;
    }

    private prepareRouteSamples(): void {
        this.routeOptions.forEach((route) => {
            this.routeSamples[route.id] = this.sampleRoute(route);
        });
    }

    private sampleRoute(route: RouteOption): Point[] {
        const samples: Point[] = [];

        route.segments.forEach((segment, segmentIndex) => {
            if (segmentIndex === 0) samples.push(segment.start);
            for (let step = 1; step <= 80; step += 1) {
                samples.push(this.cubicPoint(segment, step / 80));
            }
        });

        return samples;
    }

    private cubicPoint(segment: PathSegment, t: number): Point {
        const mt = 1 - t;
        return {
            x: mt * mt * mt * segment.start.x + 3 * mt * mt * t * segment.c1.x + 3 * mt * t * t * segment.c2.x + t * t * t * segment.end.x,
            y: mt * mt * mt * segment.start.y + 3 * mt * mt * t * segment.c1.y + 3 * mt * t * t * segment.c2.y + t * t * t * segment.end.y
        };
    }

    private getPointAt(progress: number, samples: Point[]): Point {
        if (samples.length === 0) return { x: 120, y: 480 };
        const scaled = progress * (samples.length - 1);
        const index = Math.floor(scaled);
        const nextIndex = Math.min(samples.length - 1, index + 1);
        const amount = scaled - index;
        return this.pointBetween(samples[index]!, samples[nextIndex]!, amount);
    }

    private getAngleAt(progress: number, samples: Point[]): number {
        if (samples.length < 2) return -22;
        const index = Math.min(samples.length - 2, Math.max(0, Math.floor(progress * (samples.length - 1))));
        return this.angleBetween(samples[index]!, samples[index + 1]!);
    }

    private angleBetween(from: Point, to: Point): number {
        return Math.atan2(to.y - from.y, to.x - from.x) * 180 / Math.PI;
    }

    private pointBetween(from: Point, to: Point, amount: number): Point {
        return {
            x: from.x + (to.x - from.x) * amount,
            y: from.y + (to.y - from.y) * amount
        };
    }

    private distance(from: Point, to: Point): number {
        return Math.hypot(to.x - from.x, to.y - from.y);
    }

    private pushEvent(title: string, detail: string, tone: string, icon: string): void {
        this.eventFeed = [
            { time: this.formatClock(), title, detail, tone, icon },
            ...this.eventFeed
        ].slice(0, 7);
    }

    private formatClock(): string {
        return new Date().toISOString().slice(11, 19) + ' UTC';
    }

    private formatNumber(value: number): string {
        return value.toFixed(1).replace('.0', '');
    }
}

export default PageSimulatorComponent;